module.exports = __webpack_public_path__ + "static/media/solution-banner.37aaa871.jpg";